export default function PencilIcon({ color = "currentColor", size = 13 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4727 3.69335C12.7327 3.43335 12.7327 3.00002 12.4727 2.75335L10.9127 1.19335C10.666 0.933352 10.2327 0.933352 9.97268 1.19335L8.74602 2.41335L11.246 4.91335M0.666016 10.5V13H3.16602L10.5393 5.62002L8.03935 3.12002L0.666016 10.5Z"
        fill={color}
      />
    </svg>
  );
}
